import { useContext, createContext, useRef } from 'react'
import type { MutableRefObject } from 'react'

type MenuContextProps = {
  menuRef: MutableRefObject<HTMLHcStructureMenuElement | null>
  openMenu: () => void
}

const MenuContext = createContext({} as MenuContextProps)

export const MenuProvider = ({ children }) => {
  const menuRef = useRef<HTMLHcStructureMenuElement>(null)

  const openMenu = () => {
    menuRef.current?.toggle()
  }

  return (
    <MenuContext.Provider
      value={{
        menuRef,
        openMenu
      }}>
      {children}
    </MenuContext.Provider>
  )
}

export const useMenuContext = () => {
  const context = useContext(MenuContext)

  if (context === undefined) {
    throw new Error('useMenuContext must be used within a MenuContext.Provider')
  }

  return context
}
